import { BranchError, SessionData } from "branch-sdk"
import { useRouter } from "next/router"
import { useCallback, useEffect } from "react"

export const appStoreFallback =
	"https://link.vidsup.com/Tblr4W0iPMb"

export const appStoreConstant =
	"https://link.zoomerang.app/00obnVZRXvb"

export const playStoreConstant =
	"https://link.zoomerang.app/PMvbFm5RXvb"

export const youtubeLink =
	"https://www.youtube.com/@VidsupAI"
export const tiktokLink =
	"https://www.tiktok.com/@vidsup.ai"
export const instagramLink =
	"https://www.instagram.com/vidsup.ai"

export type BranchLinkData =
	| {
			"~feature": "share"
			username: string
	  }
	| {
			"~feature": "video_gpt"
			video_gpt: {
				id: string
			}
	  }
	| {
			"~feature": "challenge"
	  }

interface BranchRedirectProps {
	users?: boolean
	fallback?: string
}

const useBranchRedirect = (props?: BranchRedirectProps) => {
	const router = useRouter()

	const { fallback, users } = props || {}

	const handleLink = useCallback(
		(error: BranchError, session: SessionData | null) => {
			if (error || !session) {
				if (fallback) router.replace(fallback)

				return
			}

			const data = session.data_parsed as BranchLinkData

			if (data["~feature"] === "video_gpt")
				return router.replace(
					"/ad-examples/single/" + data.video_gpt.id,
				)

			if (users)
				if (data["~feature"] === "share")
					return router.replace(appStoreConstant)

			if (data["~feature"] === undefined) {
				if (fallback) router.replace(fallback)

				return
			}
		},
		[users, fallback, router],
	)

	useEffect(() => {
		import("branch-sdk").then((branch) => {
			branch.default.init(
				process.env.NEXT_PUBLIC_BRANCH_IO_LIVE_KEY || "",
				{},
				handleLink,
			)
		})
	}, [handleLink])
}

export default useBranchRedirect
